// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-m_ha","advertDetailContactGroup__header":"c-m_hb","advertDetailContactGroup__value":"c-m_hc"};